<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      :persistent='true'
      width="30%"
      height="100%"
      class="modalDialog"
      no-click-animation
    >
      <CardTitle :title="pageTitle" />
      <v-card-actions class="cardWrap__scroll">
        <v-container>
          <v-form
            class="cardWrap__fromArea"
            ref="form"
            v-model="valid"
            @submit.prevent
          >
            <v-row justify="space-around" class="formHeight">
              <div class="cardWrap__fromArea__title">コース名</div>
                <v-text-field
                  v-model="fromSetData.course_name"
                  :rules="[actionrules.checkEmpty]"
                  maxlength="50"
                />
            </v-row>
            <v-row justify="start">
              <div class="cardWrap__fromArea__title">有効フラグ</div>
                <v-checkbox v-model="fromSetData.valid_flag" class="mx-2" label="有効フラグ" />
            </v-row>
          </v-form>
        </v-container>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
        <v-btn color="green darken-4" text v-if="addModeStatus" @click="RegistCourse">登録</v-btn>
        <v-btn color="green darken-4" text v-if="changeModeStatus" @click="UpdateCourse">変更</v-btn>
      </v-card-actions>
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import validater from '../../../../lib/validater';
import { UPDATE_COURSE, REGISTER_COURSE } from '@/constants/course';

export default {
    components: {
        CardTitle
    },
    data () {
        return {
            pageTitle: null,
            dialog: false,
            changeModeStatus: false,
            addModeStatus: false,
            valid: false,
            actionrules: {
                checkEmpty: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any')
            },
            fromSetData: {
                valid_flag: null,
                course_name: null,
                golf_code: null,
                golf_group_code: null,
                course_code: null
            }
        };
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addModeStatus = false;
            this.changeModeStatus = false;
            this.addOverlay = false;
            this.changeOverlay = false;
            this.fromSetData = {
                valid_flag: '',
                course_name: '',
                golf_code: '',
                golf_group_code: '',
                course_code: ''
            };
        },
        /** ----------------------------------------------
         * 変更
         * ---------------------------------------------- */
        UpdateCourse: async function () {
            if (this.$refs.form.validate()) {
                try {
                    await this.$apollo.mutate({
                        mutation: UPDATE_COURSE,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.fromSetData.golf_code,
                            course_name: this.fromSetData.course_name,
                            valid_flag: this.fromSetData.valid_flag,
                            course_code: this.fromSetData.course_code
                        }
                    }).then(res => {
                        this.CloseModal();
                    });
                } catch (error) {
                    this.error = error;
                }
            }
        },
        /** ----------------------------------------------
         * 追加
         * ---------------------------------------------- */
        RegistCourse: async function () {
            if (this.$refs.form.validate()) {
                try {
                    await this.$apollo.mutate({
                        mutation: REGISTER_COURSE,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.fromSetData.golf_code,
                            course_name: this.fromSetData.course_name,
                            valid_flag: this.fromSetData.valid_flag
                        }
                    }).then(res => {
                        this.CloseModal();
                    });
                } catch (error) {
                    this.error = error;
                }
            }
        },
        /** ----------------------------------------------
         * 親画面にて「追加」ボタン押下時の処理
         * ---------------------------------------------- */
        AddModal (golfCode) {
            this.Initialize();
            this.pageTitle = 'コース追加';
            this.fromSetData.golf_code = golfCode;
            this.fromSetData.valid_flag = 1;
            this.dialog = true;
            this.addModeStatus = true;
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        EditModal (item) {
            this.Initialize();
            this.pageTitle = 'コース編集';
            this.fromSetData.valid_flag = item.valid_flag;
            this.fromSetData.course_name = item.course_name;
            this.fromSetData.course_code = item.course_code;
            this.fromSetData.golf_group_code = item.golf_group_code;
            this.fromSetData.golf_code = item.golf_code;
            this.changeModeStatus = true;
            this.dialog = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.$emit('from-Dialog');
            this.$refs.form.resetValidation();
            this.Initialize();
        }
        /* CloseModals () {
            this.dialog = false;
            this.$refs.form.resetValidation();
            this.$emit('from-Dialog', this.FriendPlayerInfo);
            this.Initialize();
        } */
    }
};
</script>

<style scoped>

.formHeight{
  max-height: 60px;
  max-width: 100%;
}

</style>
